import { useCallback, useEffect, useState } from 'react';
import { useLocaleStore } from '@/lib/core/stores';
import { getEventVenues } from './events';
import type { EventVenueFacetDto } from '@/services/platform/api/model';

export interface UseEventVenuesResult {
  venues: EventVenueFacetDto[];
  isLoading: boolean;
  hasFetched: boolean;
  refetch: () => Promise<void>;
}

/** Fetches venue facets (the filter overlay's Venue checkbox list), scoped to a hub. */
export function useEventVenues(hubKey?: string): UseEventVenuesResult {
  const locale = useLocaleStore(state => state.locale);
  const [venues, setVenues] = useState<EventVenueFacetDto[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasFetched, setHasFetched] = useState(false);

  const refetch = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await getEventVenues({ hubKey: hubKey || undefined }, locale);
      setVenues(result);
    } finally {
      setIsLoading(false);
      setHasFetched(true);
    }
  }, [hubKey, locale]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { venues, isLoading, hasFetched, refetch };
}
